export const PRODUCT_ID_FIELDS = `
  product {
    ... on DafProduct { _id }
    ... on ClatProduct { _id }
    ... on BrandingProduct { _id }
    ... on CommunityFundProduct { _id }
    ... on IDOnly { _id }
  }
`;
